var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesforceLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 96",
    role: "img",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1798c9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 40,
    r: 30
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 34,
    r: 34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 42,
    r: 30
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 64,
    r: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 40,
    width: 98,
    height: 28,
    rx: 14,
    ry: 14
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforceLogo);
export default __webpack_public_path__ + "static/media/salesforce-logo.76d75d8ca3050614865127302749e205.svg";
export { ForwardRef as ReactComponent };